import React, { Fragment, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { push } from 'react-router-redux'
import { Processing } from 'react-wot-bootstrap'

import { KEY_CODES } from 'constants'
import { CLAN_MANAGEMENT } from 'urls'
import { leaveClan } from 'state/actions/CMT/MembersOperation'

import { LEAVING_CLAN_LOADER } from './constants'
import ClanLeavingLayout from './components/ClanLeavingLayout/ClanLeavingLayout'

const ClanLeaving = () => {
    const dispatch = useDispatch()
    const { clan, clanManagement } = useSelector(state => state)
    const { clanEntranceCooldown } = useSelector(state => ({
        clanEntranceCooldown: state.settings.clanEntranceCooldown,
    }))

    const isFetchingVisible = clanManagement.fetchingCounter > 0

    const handleLeaveClan = useCallback((reasons) => {
        dispatch(leaveClan(reasons))
    }, [])

    const openClanManagement = useCallback(() => {
        dispatch(push(CLAN_MANAGEMENT))
    }, [])

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.keyCode === KEY_CODES.ESCAPE) {
                e.stopPropagation()
                openClanManagement()
            }
        }

        document.documentElement.addEventListener('keydown', onKeyDown, false)

        return () => {
            document.documentElement.removeEventListener('keydown', onKeyDown, false)
        }
    }, [openClanManagement])

    return (
        <Fragment>
            <ClanLeavingLayout
                clan={clan}
                leaveClan={handleLeaveClan}
                openClanManagement={openClanManagement}
                clanEntranceCooldown={clanEntranceCooldown}
            />
            <Processing type="window" caption={LEAVING_CLAN_LOADER} isVisible={isFetchingVisible} />
        </Fragment>
    )
}

ClanLeaving.propTypes = {
    clan: PropTypes.shape({
        color: PropTypes.string,
        emblem: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        isClanAcceptableForAutoJoining: PropTypes.bool.isRequired,
        isRecruitingOpened: PropTypes.bool.isRequired,
        languages: PropTypes.arrayOf(PropTypes.string).isRequired,
        membersCount: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        strongholdLevel: PropTypes.number.isRequired,
        tag: PropTypes.string.isRequired,
        clanEntranceCooldown: PropTypes.number.isRequired,
    }),
}

export default ClanLeaving



// WEBPACK FOOTER //
// ./containers/ClanLeaving/ClanLeaving.jsx